export default __webpack_public_path__ + "static/media/car2png.bdd48e01.png";